import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getExperience, resetExperience } from '../../store/actions/experience';
import { navigateSpace } from '../../store/actions/app';
import { ExperienceVideoSpace, ExperiencePhotoSpace } from '../../containers/xr/space';
import { RootState } from '../../types/data';
import GatewayService from '../../services/gateway-service';
import { EXPERIENCE_LOADED } from '../../common/constants/gateway-events';
import { Helmet } from 'react-helmet';

type ExperienceRouteProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<{ experienceId?: string }>;

const mapStateToProps = (state: RootState) => ({
  experience: state.experience.current,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getExperience,
      resetExperience,
      navigateSpace,
    },
    dispatch
  );

const ExperienceRoute = ({ experience, ...props }: ExperienceRouteProps) => {
  const { experienceId } = props.match.params;

  // data fetching functional
  useEffect(() => {
    if (experienceId) {
      (async () => {
        // @ts-ignore
        const _res = await (props.getExperience(experienceId) as Promise<any>);
        if (!_res.__HANDLED_ERROR__) {
          const result = _res.payload.data.response;

          if (!result.tour) {
            const video_urls = result.video.urls;

            props.navigateSpace({
              ...result,
              video_urls,
            });
          }
        }
      })();
    }

    return () => {
      props.resetExperience();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [experienceId]);

  useEffect(() => {
    if (experience.loaded && experience.data) {
      GatewayService.emit(EXPERIENCE_LOADED, experience.data);
    }
  }, [experience.loaded, experience.data]);

  if (!experience.loaded) {
    return null;
  }

  const pageTitle = experience.data?.title;

  return (
    <>
      <Helmet>{pageTitle ? <title>{`${pageTitle} | 360 Stories`} </title> : null}</Helmet>
      {experience.data.tour ? <ExperiencePhotoSpace data={experience.data.tour.points} /> : <ExperienceVideoSpace />}
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExperienceRoute));
